import env from 'environments';
import ApiService from 'services/ApiService';
import { AxiosResponse } from 'axios';

export const toRequest = (
  requestMethod: Function,
  requestMethodOnlineParams: any,
  offlineJSONName: string
): Promise<AxiosResponse<any>> => {
  if (env.hasConfig ? env.isOffline : false) {
    const url = `/assets/mock/${offlineJSONName}.json`;
    return ApiService.get(url);
  } else {
    return requestMethod.apply({}, requestMethodOnlineParams);
  }
};

export const getErrorMessage = (errorRequest: any) => {
  if (typeof errorRequest === 'object') {
    if (
      typeof errorRequest.details === 'object' &&
      typeof errorRequest.details.length === 'number' &&
      errorRequest.details.length > 0
    ) {
      return errorRequest.details[0].message;
    } else {
      return errorRequest.message;
    }
  }
  return null;
};
